var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrgAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.25,
    height: 16.286,
    viewBox: "0 0 14.25 16.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-ninja",
    "data-name": "Icon awesome-user-ninja",
    d: "M10.35,9.2,7.125,12.424,3.9,9.2A4.261,4.261,0,0,0,0,13.436v1.323a1.527,1.527,0,0,0,1.527,1.527h11.2a1.527,1.527,0,0,0,1.527-1.527V13.436A4.261,4.261,0,0,0,10.35,9.2ZM1.018,6.107a3.037,3.037,0,0,0,2.2-.945,4.071,4.071,0,1,0,.264-2.879A3.039,3.039,0,0,0,1.018,1.018,3.045,3.045,0,0,0,2.389,3.563,3.045,3.045,0,0,0,1.018,6.107ZM5.6,3.054H8.652A1.017,1.017,0,0,1,9.67,4.071H4.58A1.017,1.017,0,0,1,5.6,3.054Z",
    fill: "#868686"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgAdmin);
export default __webpack_public_path__ + "static/media/OrgAdmin.3a76ea1d7cc521d8ee7037bdc8227256.svg";
export { ForwardRef as ReactComponent };